// extracted by mini-css-extract-plugin
export default {"timeYearList":"TimeYearList_timeYearList__kuaOb","timeYearListItem":"TimeYearList_timeYearListItem__1X2LB","current":"TimeYearList_current__Cz8up"};